import { SearchResultFacet } from './search/search-result-facet.model';
import { SearchResultRequest } from './search/search-result-request.model';
import { SearchResultMeta } from './search/search-result-meta.model';
import { Status } from '../../enums/status.enum';
import { Dto } from './dto.model';

export class SearchResultsDto<T> extends Dto {
  public facets: SearchResultFacet[] = [];
  public request: SearchResultRequest;
  public meta: SearchResultMeta;
  constructor(code: Status, public data: T[]) {
    super(code);
  }
}
